import Digestive from "./Images/digestive_system.jpeg";
import Respiratory from "./Images/respiratory_system.jpeg";
import Skin from "./Images/skin_system.jpeg";
import Skeletal from "./Images/skeletal_system.jpeg";
import Cardiovascular from "./Images/cardiovascular_system.jpeg";
import Nervous from "./Images/nervous_system.jpeg";

const SystemType = [
  {
    system: "sensory",
    img: Skin,
  },
  {
    system: "skeletal",
    img: Skeletal,
  },
  {
    system: "digestive",
    img: Digestive,
  },
  {
    system: "respiratory",
    img: Respiratory,
  },
  {
    system: "cardiovascular",
    img: Cardiovascular,
  },
  {
    system: "nervous",
    img: Nervous,
  },
];

export default SystemType;
